import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import ProductsHeader from "./components/ProductsHeader";
import ProductsHero from "./components/ProductsHero";
import ProductBlock from "./components/ProductBlock";
import ProductsCta from "./components/ProductsCta";
import ProductsFooter from "./components/ProductsFooter";
import { PRODUCTS } from "./data";

export default function ProductsPage() {
  useScrollReveal();
  const { hash } = useLocation();

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Joble Products: Web Agent, Phone Agent & Workspace";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    const timers: number[] = [];

    const scrollToTarget = (behavior: "auto" | "smooth") => {
      const target = document.getElementById(id);
      if (target) target.scrollIntoView({ behavior, block: "start" });
    };

    // Jump instantly first so we don't animate all the way down from the
    // previous page, then correct once the layout and images have settled.
    scrollToTarget("auto");
    timers.push(window.setTimeout(() => scrollToTarget("smooth"), 120));
    timers.push(window.setTimeout(() => scrollToTarget("smooth"), 500));
    timers.push(window.setTimeout(() => scrollToTarget("smooth"), 900));

    const onLoad = () => scrollToTarget("smooth");
    window.addEventListener("load", onLoad);

    return () => {
      timers.forEach((timer) => window.clearTimeout(timer));
      window.removeEventListener("load", onLoad);
    };
  }, [hash]);

  return (
    <div className="relative min-h-screen bg-background-50 overflow-x-hidden">
      <ProductsHeader />
      <main>
        <ProductsHero />
        {PRODUCTS.map((product, index) => (
          <ProductBlock key={product.id} product={product} index={index} />
        ))}
        <ProductsCta />
      </main>
      <ProductsFooter />
    </div>
  );
}